import request from './httpService';

const base = '/eyeexam/assist';

export const AssistService = {
  evaluate({ general, objective, context, options, signal }) {
    // Return full envelope { code, message, data } to match service pattern
    return request({ method: 'POST', url: `${base}/evaluate`, data: { general, objective, context, options }, signal });
  }
};
